import type { NextPage } from "next";
import type { SVGProps } from "react";

export interface FavouriteStateFalseIconProps extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FavouriteStateFalseIcon: NextPage<FavouriteStateFalseIconProps> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FavouriteStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.4943 20.5988C11.8934 20.5988 11.295 20.4199 10.784 20.0622L4.27472 15.2628C3.16921 14.4885 2.5 13.2031 2.5 11.8342V8.91174C2.5 7.3601 3.27681 5.834 4.63094 4.72356C5.50307 4.00916 6.55553 3.564 7.67479 3.4392C7.85512 3.41365 8.30813 3.40186 8.33368 3.40186C9.91088 3.40186 11.41 4.04158 12.4998 5.1471C13.59 4.04159 15.0896 3.40186 16.6663 3.40186C16.6919 3.40186 17.1414 3.41365 17.3395 3.44018C18.4445 3.56498 19.4979 4.00916 20.3691 4.72455C21.7232 5.834 22.5 7.35813 22.5 8.90782V11.8342C22.5 13.2031 21.8308 14.4885 20.7096 15.2736L14.2312 20.0514C13.708 20.417 13.1002 20.5988 12.4943 20.5988ZM8.33367 4.91126C8.30272 4.91126 7.99956 4.91716 7.86297 4.93681C7.01394 5.03213 6.23418 5.36133 5.58807 5.89099C4.58476 6.71349 4.0094 7.81409 4.0094 8.91174V11.8342C4.0094 12.7108 4.43784 13.5343 5.15569 14.0374L11.6645 18.8368C12.1583 19.1827 12.8422 19.1827 13.3507 18.825L19.8286 14.0482C20.5617 13.5343 20.9906 12.7108 20.9906 11.8342V8.90781C20.9906 7.81311 20.4157 6.71349 19.4129 5.89197C18.7668 5.36132 17.9856 5.03212 17.1547 4.93779C17.0019 4.91813 16.6978 4.91125 16.6594 4.91125C15.2562 4.91125 13.9291 5.6011 13.1169 6.75574C12.9759 6.95621 12.7454 7.0761 12.4997 7.0761C12.2541 7.0761 12.0236 6.95621 11.8821 6.75574C11.0704 5.6011 9.74382 4.91126 8.33367 4.91126Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FavouriteStateFalseIcon;
